<ng-container *ngIf="getTermValue()">
  <div class="term-currency">
    <div *qvAtNdc="termValue;disableClick: true" class="term__value">
      {{ getTermValue() | currency:termConfig.currency.code:termConfig.currency.indicatorFormat:termConfig.currency.digitsInfo }}
    </div>
  </div>
</ng-container>
<div *ngIf="isUnavailable" class="term__value term__value--unavailable">{{constants.WAC.UNAVAILABLE}}</div>
<div *ngIf="!isUnavailable && !getTermValue()" class="term__value term__value--empty"></div>
